import * as React from 'react';

import CampaignModulesDataProviderForLohp from 'bundles/campaigns/providers/CampaignModulesDataProviderForLohp';
import AiAssistanceExperimentProvider from 'bundles/front-page/providers/AiAssistanceExperimentProvider';
import FrontPageContentDataProvider from 'bundles/front-page/providers/FrontPageContentDataProvider';
import FrontPagePrefetchDataProvider from 'bundles/front-page/providers/FrontPagePrefetchedDataProvider';
import FrontPageQueryPromptsProvider from 'bundles/front-page/providers/FrontPageQueryPromptsProvider';
import AiSearchExperimentProvider from 'bundles/search-common/providers/AiSearchExperimentProvider';
import { SearchRefreshProvider } from 'bundles/search-common/providers/SearchRefreshContext';

const FrontPageDataProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <FrontPagePrefetchDataProvider>
      <FrontPageContentDataProvider>
        <CampaignModulesDataProviderForLohp>
          <AiAssistanceExperimentProvider>
            <AiSearchExperimentProvider>
              <FrontPageQueryPromptsProvider>
                <SearchRefreshProvider>{children}</SearchRefreshProvider>
              </FrontPageQueryPromptsProvider>
            </AiSearchExperimentProvider>
          </AiAssistanceExperimentProvider>
        </CampaignModulesDataProviderForLohp>
      </FrontPageContentDataProvider>
    </FrontPagePrefetchDataProvider>
  );
};

export default FrontPageDataProvider;
